<template>
  <div class="dialog" v-if="this.load">
    <!-- 详情弹窗 -->
    <div class="content">
      <div class="detail_pic">
        <div class="img">
          <img src="../../assets/left.png" class="smallImg" v-show="details.previou_id" @click="getDetails(details.previou_id)" />
          <div class="music">
            <img src="../../assets/dish.png" class="dish" />
            <img src="../../assets/stick.png" class="stick" :class="{ rotate: play }" />
            <!-- 收藏 -->
            <div @click="collect(details.is_collect)" class="collect">
              <i :class="[
                  details.is_collect === 1 ? 'is_collect' : 'no_collect',
                ]" class="el-icon-star-on"></i>
            </div>
          </div>

          <img src="../../assets/right.png" class="smallImg" v-show="details.next_id" @click="getDetails(details.next_id)" />
        </div>

        <audio :src="details.audioSrc" controls ref="audio"></audio>
        <div class="audio">
          <div class="switch">
            <img src="../../assets/play.png" v-show="!play" @click="payAudio" />
            <img src="../../assets/pause.png" v-show="play" @click="payAudio" />
          </div>
          <span>{{ currentTime }}</span>
          <div class="line">
            <div class="progress_bar" ref="progress" @click="selectPlay"></div>
            <div class="progress" :style="{ width: progressWidth + 'px' }"></div>
          </div>
          <span>{{ duration }}</span>
          <div class="voice">
            <img src="../../assets/open.png" v-show="voiceStatus" @click="voiceClick" />
            <img src="../../assets/shut.png" v-show="!voiceStatus" @click="voiceClick" />
          </div>
        </div>
        <!-- <el-image :src="require('../../assets/dish.png')">
               <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
            </el-image> -->
        <!-- <el-image :src="details.image" fit="fill"></el-image> -->
      </div>
      <div class="detail_msg">
        <div class="left">
          <div class="title">
            <img src="../../assets/02.jpg" alt="" />{{ details.title }}
          </div>
          <div class="size">
            <span>大小：{{ details.desc.size }}</span>
            <span>格式：{{ details.desc.format }}</span>
          </div>
          <div class="popular">
            <!-- 下载量 -->
            <span>
              <img height="35" width="35" src="../../assets/hot.png" alt="" />
              <!-- <img
                v-else
                height="35"
                width="35"
                src="../../assets/hot-active.png"
                alt=""
              /> -->
              {{ details.down_no }}
            </span>
            <!-- 点赞量 -->
            <span>
              <img @click="resAssess(1)" height="35" width="35" v-show="details.like_status == 0 || details.like_status == -1" src="../../assets/suport.png" alt="" />
              <img @click="resAssess(0)" v-show="details.like_status == 1" height="35" width="35" src="../../assets/suport-active.png" alt="" />
              {{ details.like_no }}
            </span>
            <!-- 👎数量 -->
            <span>
              <img @click="resAssess(-1)" height="35" width="35" v-show="details.like_status == 0 || details.like_status == 1" src="../../assets/un_suport.png" alt="" />
              <img @click="resAssess(0)" height="35" width="35" v-show="details.like_status == -1" src="../../assets/un_suport-active.png" alt="" />
              {{ details.step_no }}
            </span>
          </div>
          <div class="other">
            <span>提示:数学产品不支持退货</span>
          </div>
          <div class="other">
            <span><i class="el-icon-warning-outline"></i>举报</span>
          </div>
        </div>
        <div class="right">
          <el-button v-if="!details.is_order" type="danger" @click="buySource">立即购买</el-button>
          <el-button v-else-if="!details.is_download" type="danger" @click="download">免费下载</el-button>
          <el-button v-else type="danger" @click="download">再次下载</el-button>
        </div>
      </div>
    </div>
    <!-- <div class="bottom">
      <div class="same">
        <div class="same_top">
          <span>相似文档</span>
          <span class="i" @click="resGetList"
            ><i class="el-icon-refresh-left"></i>换一换</span
          >
        </div>
        <div class="same_content">
          <div v-for="(item, index) in dataList" :key="index">
            <div class="same_list" @click="toDetail(item.product_id)">
              <img :src="$img + item.image" alt="" />
              <div>
                <div class="list_title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { getDetail, toggleCollect, buyResource, getHotProduct, getList, assess } from '../../api/index'
export default {
  data () {
    return {
      details: {},
      load: false,
      offset: 0,
      dataList: [],
      timeLength: 0,
      auiioInterval: null,
      progressWidth: 0, // 进度条长度
      duration: '00:00', // 音频时长
      currentTime: '00:00', // 当前时间
      play: false, // 播放状态
      voiceStatus: true, // 声音开关
      audioElement: null
    }
  },
  props: {
    product_id: Number
  },
  created () {
    this.getDetails(this.product_id)
    // this.resGetList()
  },
  methods: {
    // 获取详情
    getDetails (id) {
      getDetail({ product_id: id }, res => {
        this.play = false
        this.details = res.result.data
        this.details.image = this.$imageUrl + res.result.data.image
        this.details.desc = JSON.parse(res.result.data.desc)
        this.details.audioSrc = this.$imageUrl + this.details.desc.image[0]
        this.load = true
      })
    },
    // 点赞
    resAssess (value) {
      assess({
        product_id: this.details.product_id,
        value: value
      }, res => {
        if (res.status == 'success') {
          this.details.like_status = res.result.data.data
          this.details.like_no = res.result.data.ass_no
          this.details.step_no = res.result.data.dept_no
        }
      })
    },
    // 获取相似文档
    resGetList () {
      getList({
        offset: this.offset,
        length: 3,
        type: 5
      }, res => {
        this.dataList = res.result.data
        if (res.result.total > this.offset + 3) {
          this.offset += 3
        } else {
          this.offset = 0
        }
      })
    },
    // getHot () {
    //   getHotProduct({
    //     offset: 0,
    //     length: 4,
    //     type: 5
    //   }, res => {
    //     this.dataList = res.result[0].data.splice(0, 4)
    //   })
    // },
    // 收藏
    collect (isCollect) {
      if (!this.$store.state.user.token) {
        this.$message.warning('请先登陆再进行操作')
        return
      }
      toggleCollect({ product_id: this.details.product_id, collect: isCollect ^ 1, token: this.$store.state.user.token }, res => {
        if (res.status === 'success') {
          this.details.is_collect = this.details.is_collect ^ 1
        }
      })
    },
    // 购买
    buySource () {
      if (!this.$store.state.user.token) {
        this.$message.warning('请先登陆再进行操作')
        return
      }
      buyResource({ product_id: this.details.product_id, token: this.$store.state.user.token }, res => {
        if (res.status === 'success') {
          this.details.is_order = 1
        }
      })
    },
    // 下载
    download () {
      this.$emit('download', this.details)
    },
    // 跳转详情页
    toDetail (id) {
      this.getDetails(id)
    },
    // 查看更多
    toMore () {
      this.$router.push({ path: '/audios' })
    },
    timeFormat (S) {
      if (S) {
        const m = parseInt(S / 60).toString().padStart(2, '0')
        const s = parseInt(S % 60).toString().padStart(2, '0')
        return (m + ':' + s)
      } else {
        return '00:00'
      }
    },
    // 播放音乐
    payAudio () {
      this.audioElement = document.querySelector('audio')
      if (!this.audioElement.duration) {
        this.progressWidth = 0
        console.log('未加载')
        return
      }
      this.play = !this.play
      if (this.play) {
        this.audioElement.play()
        this.auiioInterval = setInterval(() => {
          this.progressWidth = this.audioElement.currentTime / this.audioElement.duration * 800
          if (this.audioElement.ended) {
            clearInterval(this.auiioInterval)
            this.play = false
            this.progressWidth = 0
            this.audioElement.currentTime = 0
            this.currentTime = this.timeFormat(this.audioElement.currentTime)
            this.duration = this.timeFormat(this.audioElement.duration)
            this.timeLength = this.audioElement.currentTime
          } else {
            this.currentTime = this.timeFormat(this.audioElement.currentTime)
            this.duration = this.timeFormat(this.audioElement.duration)
            this.timeLength = this.audioElement.currentTime
          }
        }, 1000)
      } else {
        this.audioElement.pause()
        clearInterval(this.auiioInterval)
      }
    },
    selectPlay (e) {
      this.progressWidth = e.layerX
      this.audioElement.currentTime = this.progressWidth / 800 * this.audioElement.duration
      this.currentTime = this.timeFormat(this.audioElement.currentTime)
    },
    // 声音开关
    voiceClick () {
      this.voiceStatus = !this.voiceStatus
      // console.log(this.audioElement.muted)
      if (this.voiceStatus) {
        this.audioElement.muted = false
      } else {
        this.audioElement.muted = true
      }
    }
  },
  mounted () {
    // setTimeout(() => {
    //   this.currentTime = this.timeFormat(this.audioElement.currentTime)
    //   this.duration = this.timeFormat(this.audioElement.duration)
    // }, 500)
  },
  beforeDestroy () {
    clearInterval(this.auiioInterval)
  }
}

</script>

<style lang="scss" scoped>
.dialog {
  width: 100%;
  min-width: 864px;
  height: 100%;
  background-color: #fff;
  .content {
    width: 100%;
    margin: 0 auto;
    background-color: #ffffff;
    border-radius: 10px;
    .detail_pic {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;
      min-height: 360px;
      .img {
        width: 100%;
        position: relative;
        .music {
          width: 750px;
          height: 720px;
          margin: 0 auto;
          position: relative;
          box-shadow: 0 0 10px #cccccc;
          border-radius: 20px;
          overflow: hidden;
          margin-bottom: 60px;
          .dish {
            width: 750px;
            height: 720px;
            transform: translateX(30px);
          }
          .stick {
            display: block;
            transform: rotateX(180deg) rotateZ(-80deg);
            position: absolute;
            top: 20px;
            right: -130px;
            width: 310px;
            height: 90px;
            transform-origin: 16px 16px;
            transition: all 0.3s;
          }
          .rotate {
            transform: rotateX(180deg) rotateZ(-100deg);
          }
        }
        // .dish {
        //   width: 750px;
        //   height: 720px;
        // }
        // .stick {
        //   display: block;
        //   transform: rotateX(180deg) rotateZ(-80deg);
        //   position: absolute;
        //   top: 20px;
        //   right: -100px;
        //   width: 310px;
        //   height: 90px;
        //   transform-origin: 16px 16px;
        //   transition: all 0.3s;
        // }
        .smallImg {
          width: 60px;
          height: 50px;
          padding: 20px;
          padding-right: 10px;
          border-radius: 50%;
          background-color: rgba(50, 50, 50, 0.5);
          cursor: pointer;
          position: absolute;
          top: 40%;
        }
        .smallImg:first-child {
          padding-left: 10px;
          padding-right: 20px;
          left: 30px;
        }
        .smallImg:last-child {
          right: 30px;
        }
      }
      audio {
        display: none;
      }
      .audio {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .switch {
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }
      span {
        flex-shrink: 0;
        padding: 0 12px;
      }
      .line {
        width: 800px;
        height: 40px;
        display: flex;
        align-items: center;
        position: relative;
        .progress_bar {
          width: 100%;
          height: 4px;
          background-color: #e9e9e9;
          border-radius: 2px;
          cursor: pointer;
        }
        .progress {
          position: absolute;
          top: 20px;
          left: 0;
          transform: translateY(-50%);
          width: 0;
          height: 4px;
          border-radius: 2px;
          background-color: #616161;
          transition: width 0.3s;
          pointer-events: none;
        }
        .progress::after {
          content: '';
          position: absolute;
          top: -2px;
          right: -4px;
          width: 8px;
          height: 8px;
          background-color: #ec4141;
          border-radius: 2px;
        }
      }
      .voice {
        width: 24px;
        height: 24px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .resource {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 880px;
        max-height: 360px;
      }
      .collect {
        z-index: 999;
        position: absolute;
        top: 20px;
        right: 20px;
        width: 60px;
        height: 60px;
        font-size: 48px;
        border-radius: 50%;
        box-shadow: 0 0 9px 3px #ccc;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .is_collect {
          color: #f4ea2a;
        }
        .no_collect {
          color: #999;
        }
      }
    }
    .detail_msg {
      margin-left: 20px;
      background-color: #fff;
      padding: 20px;
      display: flex;
      justify-content: space-between;
      .right {
        display: flex;
        align-items: center;
        .el-button {
          font-size: 20px;
          margin-right: 20px;
          margin-top: 40px;
          border-radius: 6px;
          height: 60px;
          width: 300px;
        }
      }
      .title {
        font-size: 22px;
        color: #333;
        display: flex;
        align-items: center;
        img {
          width: 45px;
          height: 45px;
          margin-right: 10px;
        }
      }
      .size {
        height: 40px;
        display: flex;
        align-items: center;
        margin: 10px 0;
        span {
          margin-right: 30px;
          font-size: 18px;
          color: #999999;
        }
      }
      .base {
        margin-top: 20px;
        font-size: 18px;
        color: #000;
      }
      .popular {
        display: flex;
        align-items: center;
        margin: 10px 0;
        font-size: 12px;
        color: #999;
        cursor: pointer;
        span {
          display: flex;
          align-items: center;
          margin-right: 30px;
          img {
            margin-right: 8px;
          }
          font-size: 20px;
        }
      }
      .popular2 {
        margin: 10px 0;
        font-size: 12px;
        color: #999;
      }
      .is_collect {
        color: red;
      }
      .no_collect {
        color: #999;
      }
      .character {
        margin-bottom: 20px;
        font-size: 12px;
        color: #666;
        span {
          margin: 0 5px;
        }
      }
      .other {
        margin: 15px 0;
        span {
          color: #999999;
          font-size: 16px;
          :first-child {
            margin-right: 5px;
          }
        }
      }
      .dialog-footer {
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .bottom {
    width: 100%;
    min-height: 30px;
    margin: 0 auto;
    background-color: #ffffff;
    .same {
      background-color: #fff;
      border-radius: 10px;
      padding: 30px;
      margin-top: 20px;

      .same_top {
        display: flex;
        justify-content: space-between;
        color: #999;
        font-size: 16px;
        border-bottom: 1px solid #ccc;
        padding-bottom: 20px;
        .i {
          cursor: pointer;
        }
      }
      .same_content {
        display: flex;
        :last-child {
          margin-right: 0;
        }
        .same_list {
          margin-top: 20px;
          cursor: pointer;
          box-shadow: 0 0 8px #eeeeee;
          img {
            width: 100%;
            height: 360px;
          }
          & > div {
            padding: 10px;
            .list_title {
              font-size: 16px;
              color: #666;
            }
            .list_introduce {
              margin-top: 5px;
              margin-bottom: 10px;
              font-size: 16px;
              color: #999;
            }
          }
        }
      }
      .same_content > div {
        width: 32%;
        margin-right: 2%;
      }
    }
  }
}
</style>
